import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { UserX } from "lucide-react";
import { CONTROL } from "../../constants/testIds";
import { fadeUp } from "../../lib/motion";

// DEFECT-D-20 #7: churn is honestly defined as gyms Kairoo has suspended or deleted (see
// platform_dashboard_engine.py's docstring) — the only durable "stopped being a paying customer"
// signal this schema has, never invented.
export function ChurnedGymsPanel({ churned, loading }) {
  const reducedMotion = useReducedMotion();
  if (loading || !churned) {
    return <div className="solid-surface rounded-[14px] p-5 h-40 animate-pulse" data-testid={CONTROL.churnedPanel} />;
  }
  return (
    <motion.div {...fadeUp(reducedMotion, 0.07)} className="solid-surface rounded-[14px] p-5" data-testid={CONTROL.churnedPanel}>
      <p className="eyebrow mb-3">Churned gyms ({churned.count})</p>
      {churned.gyms.length === 0 ? (
        <p className="text-sm py-4" style={{ color: "var(--scarlet-text-secondary)" }}>No churned gyms — nothing suspended or deleted.</p>
      ) : (
        <div className="space-y-1">
          {churned.gyms.slice(0, 6).map((g) => (
            <Link key={g.organization_id} to={`/kairoo/gyms/${g.organization_id}`} className="flex items-center gap-2 px-2 py-1.5 rounded-[8px] hover:bg-black/[0.03] scarlet-focusable">
              <UserX size={13} style={{ color: "var(--scarlet-neg)" }} />
              <span className="text-sm truncate" style={{ color: "var(--scarlet-text)" }}>{g.display_name}</span>
              <span className="text-xs ml-auto capitalize" style={{ color: "var(--scarlet-text-secondary)" }}>{g.status}</span>
            </Link>
          ))}
        </div>
      )}
    </motion.div>
  );
}
